import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ResetBtn from './components/ResetBtn';
import UnassignedApkCheckBox from './components/UnassignedApkCheckBox';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import ApkTypeSelect from './components/ApkTypeSelect';
import AssignmentBtn from './components/AssignmentBtn';
import WithURLFilters from './components/WithURLFilters';
import style from './ApkControlPanel.module.scss';

const ApkControlPanel = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<AssignmentBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<ApkTypeSelect />
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<UnassignedApkCheckBox />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default ApkControlPanel;
